
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as usersfwkWStBj7bsR6vrbpmu_yeS56djFcxtb3JU1R98uVV4Meta } from "/app/pages/users.vue?macro=true";
import { default as confirmfBpPuRQ_EUHNEzBH_ghLz9v8QKlY0dk93ORH7L0pGa0Meta } from "/app/pages/confirm.vue?macro=true";
import { default as reportsXW__5CaQCHmzsdbnPnzPbeBR_Wr6OtCOqct3dvfKFW0Meta } from "/app/pages/reports.vue?macro=true";
import { default as _91_46_46_46all_93Fu6FdBvAZX2SUFvIob1QRkskf_MRPLTpS_45JeviCs5jEMeta } from "/app/pages/[...all].vue?macro=true";
import { default as customersD3LSqDiB2Tqj0wauSo5ofE6Z6_lqA8bzF4lmM363U2IMeta } from "/app/pages/customers.vue?macro=true";
import { default as indexivsxd8ejqK1S8MfTyOiFwwvyKpN_45tqE9EIbcM_EGmVwMeta } from "/app/pages/quotation/index.vue?macro=true";
import { default as createPMyonMAfJxob3M3onqtiGGIK_45oy0w66sFJ2vxpmrvxgMeta } from "/app/pages/quotation/create.vue?macro=true";
import { default as _91id_93rFRzX4rISvgxSVuy7SWaDMFpHsuv8xNWjo8_45aY1qb8IMeta } from "/app/pages/quotation/view/[id].vue?macro=true";
import { default as _91id_93j0re2KidDvZl_DZmeOyJ4zd_45wObgqFcrAwZh8dzYszwMeta } from "/app/pages/quotation/update/[id].vue?macro=true";
import { default as createA_45kLVHwPfWyLW6AUHOh8ECXDsIIwqPt_456eMBvASoFGQMeta } from "/app/pages/quotation/custom/create.vue?macro=true";
import { default as _91id_93aYET3QW0RAbzIxvtrEx4_45k7e2XvovmTXshJGUkMfO5EMeta } from "/app/pages/quotation/export-pdf/[id].vue?macro=true";
import { default as _91id_93834Lhk1vJSTa9GhEhbQqXIrAzD8DQ6bZSmioJPK2lwYMeta } from "/app/pages/quotation/custom/view/[id].vue?macro=true";
import { default as _91id_934SicdL4XADMPzmqh3YbxAO4b3RZN6xf1qMf5LDPkvgoMeta } from "/app/pages/quotation/custom/update/[id].vue?macro=true";
import { default as _91id_93OzzXsi_pzfn3LnbnpekAJ6hDpuI1MoOMcJHq2KYPOpcMeta } from "/app/pages/quotation/custom/export-pdf/[id].vue?macro=true";
import { default as quotation8OszGO1DRokOcotkG361hBkinnsbb9Qr0vc4_45n7gwBUMeta } from "/app/pages/quotation.vue?macro=true";
import { default as login_46clientJIPsK7X_wGZAFIxVUWWwLozbh70jYPLXnrpIcwP0iOMMeta } from "/app/pages/login.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/app/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as material_45reportPzE_166VoT_45MMaKr6wIKiSllHM6lMQRmnb_X108XcxIMeta } from "/app/pages/material-report.vue?macro=true";
import { default as permissionsWzBih8b9Z8y_p221bTX9xq7nupXMoSVw1YL5lRquUQcMeta } from "/app/pages/setting/permissions.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "users",
    path: "/users",
    meta: usersfwkWStBj7bsR6vrbpmu_yeS56djFcxtb3JU1R98uVV4Meta || {},
    component: () => import("/app/pages/users.vue")
  },
  {
    name: "confirm",
    path: "/confirm",
    component: () => import("/app/pages/confirm.vue")
  },
  {
    name: "reports",
    path: "/reports",
    component: () => import("/app/pages/reports.vue")
  },
  {
    name: "all",
    path: "/:all(.*)*",
    component: () => import("/app/pages/[...all].vue")
  },
  {
    name: "customers",
    path: "/customers",
    component: () => import("/app/pages/customers.vue")
  },
  {
    name: quotation8OszGO1DRokOcotkG361hBkinnsbb9Qr0vc4_45n7gwBUMeta?.name,
    path: "/quotation",
    component: () => import("/app/pages/quotation.vue"),
    children: [
  {
    name: "quotation",
    path: "",
    component: () => import("/app/pages/quotation/index.vue")
  },
  {
    name: "quotation-create",
    path: "create",
    component: () => import("/app/pages/quotation/create.vue")
  },
  {
    name: "quotation-view-id",
    path: "view/:id()",
    component: () => import("/app/pages/quotation/view/[id].vue")
  },
  {
    name: "quotation-update-id",
    path: "update/:id()",
    component: () => import("/app/pages/quotation/update/[id].vue")
  },
  {
    name: "quotation-custom-create",
    path: "custom/create",
    component: () => import("/app/pages/quotation/custom/create.vue")
  },
  {
    name: "quotation-export-pdf-id",
    path: "export-pdf/:id()",
    component: () => import("/app/pages/quotation/export-pdf/[id].vue")
  },
  {
    name: "quotation-custom-view-id",
    path: "custom/view/:id()",
    component: () => import("/app/pages/quotation/custom/view/[id].vue")
  },
  {
    name: "quotation-custom-update-id",
    path: "custom/update/:id()",
    component: () => import("/app/pages/quotation/custom/update/[id].vue")
  },
  {
    name: "quotation-custom-export-pdf-id",
    path: "custom/export-pdf/:id()",
    component: () => import("/app/pages/quotation/custom/export-pdf/[id].vue")
  }
]
  },
  {
    name: "login",
    path: "/login",
    meta: login_46clientJIPsK7X_wGZAFIxVUWWwLozbh70jYPLXnrpIcwP0iOMMeta || {},
    component: () => createClientPage(() => import("/app/pages/login.client.vue"))
  },
  {
    name: "material-report",
    path: "/material-report",
    component: () => import("/app/pages/material-report.vue")
  },
  {
    name: "setting-permissions",
    path: "/setting/permissions",
    meta: permissionsWzBih8b9Z8y_p221bTX9xq7nupXMoSVw1YL5lRquUQcMeta || {},
    component: () => import("/app/pages/setting/permissions.vue")
  }
]